import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import "@/index.css";
import App from "@/App";
import { installChunkReloadGuard } from "@/lib/chunkReload";

// Also installed by the inline script in index.html, which still runs when
// the hashed main bundle itself fails to load. The sessionStorage flag is shared.
installChunkReloadGuard();

// Register the service worker. A new version is offered by UpdatePrompt.
// Nothing here reloads the page: the first activation used to reload the
// landing before it finished painting.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
        // Check for a newer service worker right away and periodically so a
        // fresh deploy is picked up without the user hard-refreshing.
        registration.update();
        setInterval(() => registration.update(), 60 * 1000);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

// FIX 9: React Query client with sensible defaults
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,  // 5 minutes
      retry: 1,
    },
  },
});

// FIX 2: Removed react-snap hydration — use standard createRoot for React 19 compatibility
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
